import React, { useState } from 'react';
import { DimensionTableWrapper, DimensionTitle } from '../styled';
import { useSelector } from 'react-redux';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { ERROR_DIMENSION_MAP, ERROR_METRIC_MAP } from '@utils/dimension/errorCodeHelper';
import ErrorDimensionTable from '../ErrorDimensionTable';
import { tid } from '@utils/test';
import { TABLE_HEIGHT_MAPPING } from '../../header/Resize';
import RemoveDimension from '../RemoveDimension';

function ErrorDimensionWidget() {
  const metric = useSelector(selectedMetricSelector);

  const [gridRow, updateGrid] = useState(TABLE_HEIGHT_MAPPING.s);

  if (!(metric in ERROR_METRIC_MAP)) {
    return null;
  }

  const dimension = ERROR_METRIC_MAP[metric];
  const { header } = ERROR_DIMENSION_MAP[dimension];

  return (
    <DimensionTableWrapper
      id={dimension}
      {...tid(`dimension-table::${dimension}`)}
      style={{ gridRow: `span ${gridRow}` }}
    >
      <DimensionTitle>{header}</DimensionTitle>
      <RemoveDimension dimension={dimension} disabled={true} />
      <ErrorDimensionTable key={dimension} dimension={dimension} updateGrid={updateGrid} />
    </DimensionTableWrapper>
  );
}

export default ErrorDimensionWidget;
